import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Breadcrumb from "@/components/base/Breadcrumb";
import ArticleCard from "@/components/base/ArticleCard";
import { categories, categoryMap } from "@/mocks/categories";
import { getArticlesByCategory, type Article } from "@/mocks/articles";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState<string>(slug || "yule");
  const [articles, setArticles] = useState<Article[]>([]);

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
    }
  }, [slug]);

  useEffect(() => {
    setArticles(getArticlesByCategory(activeSlug));
  }, [activeSlug]);

  const category = categoryMap[activeSlug];
  const title = category ? `${category.name} - 51黑料网` : "分类 - 51黑料网";
  const description = category
    ? `${category.description}，51黑料网每日更新${category.name}最新黑料内容。`
    : "51黑料网分类浏览，按领域查看最新黑料内容。";

  return (
    <>
      <SEO
        title={title}
        description={description}
        keywords={`51黑料网,${category?.name || ""},今日黑料,黑料每日更新`}
        canonicalUrl={`https://www.51heiliaowang.com/category/${activeSlug}`}
      />
      <ScrollToTop />
      <Navbar />

      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/60">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: category?.name || "分类" },
              ]}
            />
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-3">
              {category?.name || "分类"}
            </h1>
            <p className="mt-2 text-foreground-600 text-sm">{category?.description}</p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
          <div className="flex items-center gap-2 overflow-x-auto pb-2 flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`whitespace-nowrap px-4 py-2 rounded-full text-sm transition-colors duration-200 cursor-pointer ${
                  activeSlug === cat.slug
                    ? "bg-primary-500 text-white"
                    : "bg-background-100 text-foreground-600 hover:bg-background-200"
                }`}
              >
                <i className={`${cat.icon} mr-1.5`}></i>
                {cat.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 pb-14">
          {articles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {articles.map((article) => (
                <ArticleCard key={article.id} article={article} variant="default" />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <i className="ri-inbox-line text-4xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500">该分类暂无内容，请浏览其他分类</p>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </>
  );
}